export default __webpack_public_path__ + "images/1dc988f8065ab5c0ea275b51309d01f9.svg";